module.exports = __webpack_public_path__ + "static/media/belgium-flag.b9c7cce0.png";